/**
 * Serviço de pagamento via Mercado Pago para a loja de eBooks.
 * - Cartão/PIX: cantate-api (/api/mercadopago/ebooks/*).
 * - Registro da compra após aprovação: loja-api (/api/purchases/record-mercadopago).
 *
 * O PREÇO é sempre decidido no backend (catálogo do servidor). O front só envia
 * os IDS dos itens do carrinho + o método escolhido.
 */

const API_BASE_URL =
  (typeof window !== 'undefined' && window.__REACT_APP_API_URL) ||
  process.env.REACT_APP_API_URL ||
  'http://localhost:5059';

const LOJA_API_URL =
  (typeof window !== 'undefined' && window.__REACT_APP_LOJA_API_URL) ||
  process.env.REACT_APP_LOJA_API_URL ||
  'http://localhost:4001';

async function postJson(base, path, body) {
  const res = await fetch(`${base}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  return data;
}

/** Monta o array de itens (apenas ids/títulos — o preço vem do servidor). */
function toItens(cartItems) {
  return (cartItems || []).map((it) => ({
    itemId: it.id,
    title: it.title || it.name || it.id,
  }));
}

export const mercadoPagoService = {
  /**
   * Pagamento com CARTÃO. `card` = { token, paymentMethodId, issuerId?, installments }.
   * payer = { email, name?, cpf? }.
   */
  payCard: ({ userId, origem = 'loja', cartItems, card, payer, deviceId }) =>
    postJson(API_BASE_URL, '/api/mercadopago/ebooks/card', {
      userId,
      origem,
      itens: toItens(cartItems),
      token: card.token,
      paymentMethodId: card.paymentMethodId,
      issuerId: card.issuerId,
      installments: card.installments || 1,
      deviceId,
      payer,
    }),

  /** Pagamento PIX. Retorna qrCode (copia-e-cola) + qrCodeBase64. */
  payPix: ({ userId, origem = 'loja', cartItems, payer }) =>
    postJson(API_BASE_URL, '/api/mercadopago/ebooks/pix', {
      userId,
      origem,
      itens: toItens(cartItems),
      payer,
    }),

  /** Consulta status do pagamento (polling do PIX). */
  getStatus: async (id) => {
    const res = await fetch(`${API_BASE_URL}/api/mercadopago/ebooks/status/${id}`);
    return res.json();
  },

  /**
   * Registra as compras na loja após a aprovação (verifica na cantate-api e usa
   * os itens autoritativos do servidor). payer = { email, cpf?, name? }.
   */
  record: ({ mpPaymentId, email, cpf, name }) =>
    postJson(LOJA_API_URL, '/api/purchases/record-mercadopago', {
      mpPaymentId,
      email,
      cpf,
      name,
    }),
};
